export default __webpack_public_path__ + "images/X3.29d2e70.png";